import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=2c4cba58&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=ts&"
export * from "./Profile.vue?vue&type=script&lang=ts&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=2c4cba58&prod&lang=scss&scoped=true&"
import style1 from "./Profile.vue?vue&type=style&index=1&id=2c4cba58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4cba58",
  null
  
)

export default component.exports